import React from 'react';

import { DatePickerInput } from 'components/shared/DatePickerInput';

const DatePickerInputField = ({
  field,
  helpers,
  ...restProps
}: { field: any; helpers: any } & Record<string, any>) => {
  const handleChange = (value: any) => {
    helpers.setValue(value);
  };

  return (
    <DatePickerInput
      {...restProps}
      value={field.value}
      onChange={handleChange}
    />
  );
};

export default React.memo(DatePickerInputField) as any;
